import { Injectable } from '@angular/core';
import { LocalApiService } from '../api/local/local-api.service';

@Injectable({
  providedIn: 'root'
})
export class MenuConfigService {

  constructor(private localApiService: LocalApiService) { }

  public getProducts() {
    return this.localApiService.getProducts();
  }
}
